/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 */
import { api } from '../../../config/api';

import type { SettingsOverviewData } from '../types';

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getSettingsSettings: build.query<SettingsOverviewData, void>({
      query: () => ({ method: 'GET', url: `/v1/settings` }),
    }),
  }),
  overrideExisting: true,
});

export { injectedRtkApi as getSettingsSettingsApi };
export const { useGetSettingsSettingsQuery, useLazyGetSettingsSettingsQuery } = injectedRtkApi;
